import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 64px;
  padding-bottom: 228px;
  width: 90%;
  max-width: 1124px;

  ${props => props.theme.isLarge && `
    margin-top: 48px;
    padding-bottom: 200px;
  `};

  ${props => props.theme.isXLarge && `
    margin-top: 64px;
    padding-bottom: 228px;
  `};

  ${props => props.theme.isMobileOrTablet && `
    width: 100%;
    padding: 0 28px 160px 28px;
  `};

  ${props => props.theme.isMobile && `
    flex-direction: column;
    margin-top: 24px;
    padding: 0 20px 102px 20px;
  `};
`;

const Quote = styled.label`
  color: ${props => props.theme.primaryColor};
  font-family: ${props => props.theme.fontFamilyHeader};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 80px;
  line-height: 0;
  margin-top: 40px;

  ${props => props.theme.isMobile && `
    font-size: 50px;
    line-height: 120%;
    margin: 0;
  `};
`;

const Text = styled.label`
  color: ${props => props.theme.bodyColor};
  font-family: ${props => props.theme.fontFamilyHeader};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 24px;
  line-height: 130%;
  margin: 0 32px;

  ${props => props.theme.isXLarge && `
    font-size: 32px;
  `};

  ${props => props.theme.isMobileOrTablet && `
    margin: 0 16px;
  `};

  ${props => props.theme.isMobile && `
    font-size: 16px;
    margin: -24px 0 0 0;
  `};
`;

export default function Headline({ headlineGrab }) {
  return (
    <Container>
      <Quote>&ldquo;</Quote>
      <Text>{headlineGrab}</Text>
    </Container>
  );
}

Headline.propTypes = {
  headlineGrab: PropTypes.string.isRequired,
};
